  $(document).ready(function() {
    const announcementHeight = $('.announcement__bar').outerHeight() || 0;
    let pastAnnouncement = false;
    let ticking = false;

    $(window).on('scroll', function() {
        if (!ticking) {
            requestAnimationFrame(() => {
                checkScroll();
                ticking = false;
            });
            ticking = true;
        }
    });

    function checkScroll() {
        if ($(window).scrollTop() > announcementHeight && !pastAnnouncement) {
            pastAnnouncement = true;
            animateLogo(true);
        } else if ($(window).scrollTop() < announcementHeight && pastAnnouncement) {
            pastAnnouncement = false;
            animateLogo(false);
        }
    }

    function animateLogo(up) {
        if (up) {
            console.log('animatingLogoUp');
            $('.header__logo img').each(function() {
                let id = this.id;
                if (id !== 'logo-head' && window.innerWidth < 750) {
                    $(this).addClass(`${id}-scrolled-mobile`);
                } else {
                    $(this).addClass(`${id}-scrolled`);
                }
            });
            if (window.innerWidth > 749) {
                $('.header__desktop__upper').addClass('header__desktop__upper-scrolled');
            }
        } else {
            console.log('animatingLogoDown');
            $('.header__logo img').each(function() {
                let id = this.id;
                if (id !== 'logo-head' && window.innerWidth < 750) {
                    $(this).removeClass(`${id}-scrolled-mobile`);
                } else {
                    $(this).removeClass(`${id}-scrolled`);
                }
            });
            if (window.innerWidth > 749) {
                $('.header__desktop__upper').removeClass('header__desktop__upper-scrolled');
            }
        }
    }
});